"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarPreview = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styles_1 = require("../../styles");
const layout_1 = require("../layout");
const avatar_1 = require("./avatar");
const Container = (0, styles_1.styled)(layout_1.Column)(({ size }) => ({
    position: 'relative',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    height: size,
    width: size,
    borderRadius: size / 2,
}));
const AvatarPreview = (_a) => {
    var { size, src, name } = _a, props = __rest(_a, ["size", "src", "name"]);
    const theme = (0, styles_1.useTheme)();
    const [hovered, setHovered] = react_1.default.useState(false);
    return ((0, jsx_runtime_1.jsxs)(Container, Object.assign({ onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), size: size }, { children: [(0, jsx_runtime_1.jsx)(avatar_1.Avatar, { src: src, displayName: name, size: "xlarge" }), hovered && ((0, jsx_runtime_1.jsx)(layout_1.Column, Object.assign({ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, bg: theme.colors.hoverBlue, opacity: 0.9, justifyContent: "center", alignItems: "center" }, { children: props.children })))] })));
};
exports.AvatarPreview = AvatarPreview;
//# sourceMappingURL=avatar_preview.js.map